import { render } from "./ProductRow.vue?vue&type=template&id=5257dfc6&scoped=true"
import script from "./ProductRow.vue?vue&type=script&lang=js"
export * from "./ProductRow.vue?vue&type=script&lang=js"

import "./ProductRow.vue?vue&type=style&index=0&id=5257dfc6&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5257dfc6"]])

export default __exports__